import PropTypes from "prop-types";

export default function BlockDeleteClass(props) {
  const { classDetails, handleCloseModal } = props;

  const handleDeleteClass = () => {};
  return (
    <>
      <div className="my-6">
        <span>
          Are you sure you want to Delete the{" "}
          <u>
            <strong>{classDetails.title}</strong>
          </u>{" "}
          class!
        </span>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          className="inline-flex justify-center px-8 py-2 text-sm font-medium text-zinc-900 bg-transparent border-2 border border-zinc-200 rounded-md hover:bg-zinc-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
          onClick={handleCloseModal}
          //   disabled={isUpdateLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="ml-2 inline-flex justify-center px-8 py-2 text-sm font-medium text-white bg-black border border-transparent rounded-md hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
          onClick={() => handleDeleteClass()}
        >
          Save
        </button>
      </div>
    </>
  );
}

BlockDeleteClass.propTypes = {
  handleCloseModal: PropTypes.func,
  classDetails: PropTypes.object,
};

BlockDeleteClass.defaultProps = {
  handleCloseModal: () => {},
  classDetails: {},
};
